import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  lottieSize: {
    width: 80,
    height: 80,
  },
});
